const TODAY = new Date().toISOString().split("T")[0];
const LABEL = new Date().toLocaleDateString("en-GB",{weekday:"long",day:"numeric",month:"long",year:"numeric"});
const fmt = n => (n||0).toLocaleString("en-SA",{minimumFractionDigits:0,maximumFractionDigits:0});
let _wsCurrency = "SAR";
const setCurrency = c => { _wsCurrency = c; };
const getCurrency = () => _wsCurrency;
const fmtSAR = n => `${_wsCurrency} ${fmt(n)}`;
const fmtCur = (n, cur) => `${cur||_wsCurrency} ${fmt(n)}`;
const fmtCompact = n => {const a=Math.abs(n||0);if(a>=1000000)return`${_wsCurrency} ${(n/1000000).toFixed(1)}M`;if(a>=1000)return`${_wsCurrency} ${(n/1000).toFixed(n>=10000?0:1)}k`;return fmtSAR(n);};
const fmtShort = n => {const a=Math.abs(n||0);const s=n<0?"-":"";if(a>=1000000)return`${s}${(a/1000000).toFixed(1)}M`;if(a>=1000)return`${s}${(a/1000).toFixed(a>=10000?0:1)}k`;return`${s}${a.toLocaleString("en-SA",{minimumFractionDigits:0,maximumFractionDigits:0})}`;};
const fmtDate = (iso, lang="en") => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  const locale = lang === "ar" ? "ar" : "en-GB";
  try { return d.toLocaleDateString(locale, {day:"numeric",month:"short",year:"numeric"}); }
  catch { return iso; }
};
const fmtDateRange = (start, end, lang="en") => {
  const s = fmtDate(start, lang);
  const e = fmtDate(end, lang);
  if (s && e) return `${s} → ${e}`;
  return s || e || "";
};
export { TODAY, LABEL, fmt, fmtSAR, fmtCur, fmtCompact, fmtShort, fmtDate, fmtDateRange, setCurrency, getCurrency };
